/**
 * Intl.NumberFormat object. Use this for manual conversions
 * in code and for greater low-level control
 * @mdn https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/format
 */
export const USDFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});
